const SyncConstants = {
    "syncBaseURL" : "https://slotify.shared-02.uo-cloud.de/rest/",
    "slotifyVersion" : "20230316"
}

export default SyncConstants;